export const ExposureCategory = {
    
  Sector_Gross: -127, // 11
  Geography_Gross: -128, // 21
  Market_Cap_Gross: -130, // 41
  Asset_Concentration_Gross: -132, // 71
  Asset_Level_Of_Gross: -133, // 81

  Sector: 127,
  Geography: 128,
  Strategy: 129,
  MarketCap: 130,
  Liquidity: 131,
  Concentration: 132,
  AssetLevel: 133,
  TotalNumberPositions: 134,
  Leverage: 135,
  ProductAssetClass: 136,
  RatesCurrency: 137,
  OptionPremium: 138,
  OptionDAE: 139,
  AUM: 140,
  Valuations: 141,
  Privates: 142,
  Credit: 143,
};
